var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningComputer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13.75H2.5V3.75H17.5V13.75ZM11.25 17.5H8.75V15H11.25V17.5ZM17.5 2.5H2.5C1.80937 2.5 1.25 3.05937 1.25 3.75V13.75C1.25 14.4406 1.80937 15 2.5 15H7.5V17.5H5V18.75H15V17.5H12.5V15H17.5C18.1906 15 18.75 14.4406 18.75 13.75V3.75C18.75 3.05937 18.1906 2.5 17.5 2.5Z",
    fill: "#F67E7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningComputer);
export default __webpack_public_path__ + "static/media/warning-computer.dffda2a53141fce00c0db67d51e2619d.svg";
export { ForwardRef as ReactComponent };